import React from "react";
import useInput from "./hooks/use-input";

// import { Button } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import DeleteIcon from "@mui/icons-material/Delete";

//To use the hook
function InfoForm(props) {
  const {
    value: enteredName,
    isValid: enteredNameIsValid,
    hasError: nameInputHasError,
    valueChangeHandler: nameChangedHandler,
    inputBlurHandler: nameBlurHandler,
    reset: resetNameInput,
  } = useInput((value) => value.trim() !== "");

  const {
    value: enteredLastName,
    isValid: enteredLastNameIsValid,
    hasError: lastNameInputHasError,
    valueChangeHandler: lastNameChangedHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastNameInput,
  } = useInput((value) => value.trim() !== "");

  const {
    value: enteredEmail,
    isValid: enteredEmailIsValid,
    hasError: emailInputHasError,
    valueChangeHandler: emailChangedHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmailInput,
  } = useInput((value) => value.includes("@"));

  const {
    value: enteredCell,
    isValid: enteredCellIsValid,
    hasError: cellInputHasError,
    valueChangeHandler: cellChangedHandler,
    inputBlurHandler: cellBlurHandler,
    reset: resetCell,
  } = useInput((value) => value.trim() !== "");

  let formIsValid = false;

  if (
    enteredNameIsValid &&
    enteredLastNameIsValid &&
    enteredEmailIsValid &&
    enteredCell
  ) {
    formIsValid = true;
  }

  const formSubmissionHandler = (event) => {
    event.preventDefault(); //stops the server from reloading

    if (
      !enteredNameIsValid ||
      !enteredLastNameIsValid ||
      !enteredEmailIsValid ||
      !enteredCellIsValid
    ) {
      return;
    }

    console.log(enteredName);
    console.log(enteredLastName);
    console.log(enteredEmail);
    console.log(enteredCell);

    resetNameInput();
    resetEmailInput();
    resetLastNameInput();
    resetCell();
  };

  const nameInputClasses = nameInputHasError //use this for the custom classes
    ? "form-control invalid"
    : "form-control";

  const emailInputClasses = emailInputHasError //use this for the custom classes
    ? "form-control invalid"
    : "form-control";

  return (
    <>
      <div className="mr-8 md:mr-4 mt-10 sm:mt-px">
      <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
          Let’s Talk About Your Event Experience Needs.
        </h2>
        <h3 className="mb-2 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">
          Call us at (xxx) xxx-xxxx or fill out the form below to get started!
        </h3>
        <h4 className="mb-2 font-light text-center text-gray-500 dark:text-gray-400 text-xs pb-2">
          For general event inquiries, please continue to complete the form
        </h4>
        <form onSubmit={formSubmissionHandler} className="w-full">
          <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                for="grid-first-name"
              >
                First Name
              </label>
              <input
                type="text"
                id="grid-first-name"
                onChange={nameChangedHandler}
                onBlur={nameBlurHandler}
                value={enteredName}
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                //   placeholder="enter name"
              />
              {nameInputHasError && (
                <p className="text-red-500 text-xs  border-red-500 italic">
                  Please enter your first name.
                </p>
              )}
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                for="grid-last-name"
              >
                Last Name
              </label>
              <input
                type="text"
                id="grid-last-name"
                onChange={lastNameChangedHandler}
                onBlur={lastNameBlurHandler}
                value={enteredLastName}
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                //   placeholder="Doe"
              />
              {lastNameInputHasError && (
                <p className="text-red-500 text-xs  border-red-500 italic">
                  Please enter your last name.
                </p>
              )}
            </div>
          </div>
          <div class="flex flex-wrap -mx-3 mb-2">
            <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                for="grid-city"
              >
                email
              </label>
              <input
                type="email"
                id="grid-city"
                onChange={emailChangedHandler}
                onBlur={emailBlurHandler}
                value={enteredEmail}
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                //   placeholder="Albuquerque"
              />
              {emailInputHasError && (
                <p className="error-text text-red-500 text-xs  border-red-500 italic">
                  Please Enter a valid email.
                </p>
              )}
            </div>

            <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                for="grid-phone"
              >
                Cell Phone
              </label>
              <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                id="grid-phone"
                type="text"
                onChange={cellChangedHandler}
                onBlur={cellBlurHandler}
                value={enteredCell}
                placeholder=""
              />
              {cellInputHasError && (
                <p className="error-text text-red-500 text-xs  border-red-500 italic">
                  Please Enter a valid cell phone number.
                </p>
              )}
            </div>

            <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                for="grid-state"
              >
                Number of People
              </label>
              <div>
                <select
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                  id="grid-state"
                >
                  <option>0 to 100</option>
                  <option>100 to 200</option>
                  <option>200 to 300</option>
                  <option>300 to 500</option>
                  <option>500 to 700</option>
                  <option>700 to 1,000</option>
                  <option>1,000 to 1,500</option>
                  <option>1,500 to 2,000</option>
                  <option>2,000 to 3,000</option>
                  <option>Greater than 3,000</option>
                </select>
              </div>
            </div>
          </div>
          <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700"/>

          {/* Form 2 */}

          <h2 className="mt-4 mb-2 dark:text-gray-300">Type of Event</h2>
          <div >
            <div class="text-left ">
              <div>
                {/* CorporateEvent */}
                <div className="form-check">
                  <input
                    className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                  />
                  <label
                    className="form-check-label inline-block text-gray-800 dark:text-gray-300"
                    for="flexCheckDefault"
                  >
                    CorporateEvent
                  </label>
                </div>
                {/* Business Expo */}
                <div class="form-check">
                  <input
                    className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label inline-block text-gray-800 dark:text-gray-300"
                    for="flexCheckChecked"
                  >
                    Business Expo
                  </label>
                </div>
                {/* Sales Meeting / Presentation */}
                <div class="form-check">
                  <input
                    className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label inline-block text-gray-800 dark:text-gray-300"
                    for="flexCheckChecked"
                  >
                    Sales Meeting / Presentation
                  </label>
                </div>
                {/* Convention */}
                <div class="form-check">
                  <input
                    className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label inline-block text-gray-800 dark:text-gray-300"
                    for="flexCheckChecked"
                  >
                    Convention
                  </label>
                </div>
                {/* Banquet / Awards */}
                <div class="form-check">
                  <input
                    className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label inline-block text-gray-800 dark:text-gray-300"
                    for="flexCheckChecked"
                  >
                    Banquet / Awards
                  </label>
                </div>
                {/* Wedding / Reception */}
                <div class="form-check">
                  <input
                    className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label inline-block text-gray-800 dark:text-gray-300"
                    for="flexCheckChecked"
                  >
                    Wedding / Reception
                  </label>
                </div>
                {/* Private Party */}
                <div class="form-check">
                  <input
                    className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label inline-block text-gray-800 dark:text-gray-300"
                    for="flexCheckChecked"
                  >
                    Private Party
                  </label>
                </div>
                {/* Other */}
                <div class="form-check">
                  <input
                    className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label inline-block text-gray-800 dark:text-gray-300"
                    for="flexCheckChecked"
                  >
                    Other
                  </label>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              {/* Event Start Date */}
              <div className="w-full md:w-1/2 px-3 mt-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                  for="grid-last-name"
                >
                  Event Start Date
                </label>
                <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                id="grid-last-name"
                  type="date"
                  //   placeholder="Doe"
                />
              </div>
              {/* Number of People */}
              <div className="w-full md:w-1/2 px-3 mt-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                  for="grid-last-name"
                >
                  Number of People
                </label>
                <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                id="grid-last-name"
                  type="number"
                  //   placeholder="Doe"
                />
              </div>
              {/* How many days */}
              <div className="w-full md:w-1/2 px-3 mt-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                  for="grid-last-name"
                >
                  How many days?
                </label>
                <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                id="grid-last-name"
                  type="number"
                  //   placeholder="Doe"
                />
              </div>
              {/* Number of People */}
              <div className="w-full md:w-1/2 px-3 mt-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 dark:text-gray-300"
                  for="grid-last-name"
                >
                  Venue
                </label>
                <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                id="grid-last-name"
                  type="text"
                  //   placeholder="Doe"
                />
              </div>
            </div>
          </div>

          {/* Send a Message Form */}
          <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700"/>
          <div className="flex mx-auto items-center justify-center">
            <form className="w-full  bg-gray-900 rounded-lg px-4">
              <div className="flex flex-wrap -mx-3 mb-6">
                <h2 class="block uppercase tracking-wide text-gray-700 text-xs font-bold my-2 dark:text-gray-300">
                  Send A Message
                </h2>
                <div className="w-full md:w-full  my-2 ">
                  <textarea
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                name="body"
                    id=""
                    cols="30"
                    rows="10"
                    placeholder="Type Your comment"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
            <button disabled={!formIsValid} className="bg-transparent hover:bg-cyan-500 text-cyan-300 font-semibold hover:text-white py-2 px-4 border border-cyan-500 hover:border-transparent rounded mb-4" >Submit</button>
        </form>
      </div>
    </>
  );
}

export default InfoForm;
